
<template>
  <div class="">
    <b-card>
      <div class="row ml-1">
        <label class="font-weight-bold"> {{ $t('dashboard.licenses.pending') }}</label>
        <b-button @click="goTo(`${routes.members.licenses.pending}`)" size="sm" variant="primary"
          class="ml-auto mr-3 esep-blue-bg text-light" v-b-tooltip.hover
          :title="$t('dashboard.licenses.showLicenseProposals')">
          <b-icon icon="arrow-right-circle-fill"></b-icon>
        </b-button>
      </div>
      <b-table id="licenses-table" perPage="5" striped hover borderless :items="licensesList" :fields="fields" responsive
        show-empty class="mt-2" thead-class="esep-blue-bg text-light" :busy="isLoading">

        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template v-slot:empty="">
          <h6>{{ $t("dashboard.licenses.emptyTable") }}</h6>
        </template>
      </b-table>
    </b-card>


  </div>
</template>

<script>
import EsepService from "../../services/esep.service";
import { routes } from "../../services/routing.service";
import { handleApiError } from "../../services/error.service";

export default {
  props: {
    unitId: Number
  },
  mounted() {
    this.getPendingLicenses();
  },
  data() {
    return {
      selectedUnitId: Number(this.$store.state.globalUnitId) || this.$store.state.userInfo.orgMember.orgUnit.id,
      licensesList: [],
      isLoading: false,
      fields: [
        { key: "member.surName", label: "Επώνυμο", sortable: false, thClass: 'text-left', tdClass: 'text-left' },
        { key: "member.firstName", label: "Όνομα", sortable: false, thClass: 'text-left', tdClass: 'text-left' },
        { key: "title", label: "Καθήκοντα", sortable: false, thClass: 'text-left', tdClass: 'text-left', formatter: "translateTitle" },
        { key: "type", label: "Είδος Πρότασης", sortable: false, thClass: 'text-left', tdClass: 'text-left', formatter: "translateType" },
        { key: "orgUnit.name", label: "Κλιμάκιο", sortable: false, thClass: 'text-left', tdClass: 'text-left' },
        // { key: "action", label: "Ενέργεια", sortable: false , tdClass: 'actionClass3' },
      ],
      routes: routes
    }
  },
  watch: {
    unitId(newUnitId) {
      this.selectedUnitId = newUnitId;
      this.getPendingLicenses();
    }
  },
  methods: {
    goTo(link) {
      location.replace(link);
    },
    getPendingLicenses() {
      this.isLoading = true;
      EsepService.getLicensesProposalsByCriteria(this.selectedUnitId).then(
        (response) => {
          this.$log.debug("Pending Licenses:")
          this.$log.debug(response.data);
          this.licensesList = response.data;
          this.isLoading = false;
        },
        (error) => {
          if (error.response.status == 401 || error.response.status == 403) {
            this.$emit('show-comp', { name: 'licenses', value: false });
          } else {
            let errorMessage = handleApiError(error);
            this.$emit('error:api', errorMessage);
          }
          this.isLoading = false;
        }
      )
    },
    translateTitle(title) {
      return this.$t(`licensesEnums.${title}`)
    },
    translateType(type) {
      return this.$t(`licenseTypesEnums.${type}`)
    }

  }
}
</script>

<style></style>